import Vue from "vue";
import router from "./router/index.js";
import store from "./store/index.js";
import App from "./App.vue";

import "@/assets/css/common.css";
import "@/utils/vant-ui";
import { getEnvName } from "./utils/env.js";
import aixos from "./h5-network/request.js";
import envs from "./utils/envs.js"
import userLoginToJudge from './services/userLoginToJudge.js';
Vue.prototype.$http = aixos;

Vue.config.productionTip = false;

if (
    process.env.VUE_APP_ENV_TYPE !== "production" &&
    process.env.VUE_APP_ENV_TYPE !== "development"
) {
    const VConsole = require("vconsole");
    new VConsole();
}

router.afterEach((to, from) => {
    document.title = to.meta.name || "北斗智保";
    //页面进入、停留埋点
    let baseTime = new Date().getTime();
    if (to.meta.title) {
        to.meta.baseTime = baseTime;
        window.sensors?.track('BDpageview', {
            $title: to.meta.title,
            project_name: '北斗智保2021'
        })
    }
    if (from.meta.baseTime) {
        window.sensors?.track('pageviewStay', {
            $title: from.meta.title,
            $event_duration: (baseTime - from.meta.baseTime) / 1000,
            project_name: '北斗智保2021'
        })
    }
});

Vue.mixin({
    methods: {
        sensorsAdd(name, prop) {
            prop.project_name = '北斗智保2021'
            window.sensors?.track(name, prop);
        }
    }
});

// 判断是哪一个环境的代码，提升到入口，避免散落在各个组件内。环境名称不会轻易变更
getEnvName()
    //userLoginToJudge: 判断金牛环境
    .then(() => userLoginToJudge())
    .then(function (envName) {
        const env = envs[envName];
        // 执行环境对应的main函数
        env.main();
        // 动态添加环境下的路由
        env.routes.forEach(function (config) {
            router.addRoute(config);
        });
        // 动态注册环境下的store模块，模块命名和环境名一致
        store.registerModule(envName, env.storeModule)
        new Vue({
            router,
            store,
            render: h => h(App),
        }).$mount("#app");
    });

const IS_IOS = window.navigator.userAgent.toUpperCase().indexOf('MAC OS') !== -1;

//解决 键盘恢复后留白问题
if (IS_IOS) {
    document.body.addEventListener("focusout", () => {
        //软键盘收起的事件处理
        setTimeout(() => {
            const scrollHeight =
                document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
    });
}
